module.exports = __webpack_public_path__ + "img/softinya-5.28fead8f.png";